import React from 'react';
import {Button} from "@material-ui/core";

const PrimaryButton = ({children,onClick,style}) => 
{
    return <Button  onClick={onClick}  style={{backgroundColor: "#0088FF",...style}}
    variant="contained" color="primary">{children}</Button>
}

export default PrimaryButton
